import { cn } from '@medizzconnect/shared';

interface VideoCardSkeletonProps {
  className?: string;
}

export function VideoCardSkeleton({ className }: VideoCardSkeletonProps) {
  return (
    <div
      className={cn(
        'overflow-hidden bg-white',
        className,
      )}
      aria-hidden="true"
    >
      {/* V1-Style: nur Thumbnail-Platzhalter, Aspekt 5:4 */}
      <div className="w-full animate-pulse bg-slate-200" style={{ aspectRatio: '5/4' }} />
    </div>
  );
}
